import React from 'react'

import styled from 'styled-components'

import i18n from 'live/services/i18n'

export function ImporterHeader(): JSX.Element {
    return (
        <HeaderContainer>
            <MainContainer>
                <TitleContainer>
                    <span>APPS</span>
                    <label>{i18n('Static Data Importer')}</label>
                </TitleContainer>
            </MainContainer>
        </HeaderContainer>
    )
}
export const HeaderContainer = styled.div`
    width: 100%;

    background-color: var(--gray-200);
`
export const MainContainer = styled.div`
    font-family: arial, sans-serif;
    height: 100%;
    overflow: hidden;
    position: relative;

    background-color: transparent;
`
export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 2px solid var(--gray-400);
    padding: 15px 10%;
    min-width: 940px;

    span {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        padding-right: 8px;
        border-right: 2px solid var(--gray-400);
    }

    label {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        padding: 0 8px;
    }
`
